import { memo } from "react";
import { Link } from "react-router-dom";

import styled from "styled-components";

import Tab, { TabProps } from "@mui/material/Tab";

// -----------------------------------------------------------------------------

const LinkTab = memo(function LinkTab(props: LinkTabProps): JSX.Element {
  return <TabStyled component={Link} {...props} />;
});

export default LinkTab;

// -----------------------------------------------------------------------------

const TabStyled: typeof Tab = styled(Tab)`
  text-decoration: none;
`;

// -----------------------------------------------------------------------------

interface LinkTabProps extends TabProps<typeof Link> {}
